import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { PatientService } from '../../_service/patient.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-patient-list',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.css']
})
export class PatientListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  walletForm: FormGroup;
  perpage:number=25;usersList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;currentUserId:any;loaded:boolean=false;search:string;submitted: boolean = false;glamyoPatientId=''
  constructor(private sharedapi:SharedService,private patientapi:PatientService,private formBuilder: FormBuilder) {

    this.walletForm = this.formBuilder.group({
      'wallet': [null]
    });


   }
   get f() { return this.walletForm.controls; }

   async createWallet() {
     this.submitted = true;
     this.loading = true;
     if (this.walletForm.invalid) {
       this.loading = false;
       return;
     }
 
     this.walletForm.value.glamyo_patient_id = this.glamyoPatientId;
     await this.patientapi.saveEditWallet(this.walletForm.value).subscribe((data: any) => {
       this.submitted = false;
       this.loading = false;
       if (data.status) {
         this.hideModal();
         this.walletForm.reset();
         this.sharedapi.presentToast(data.msg);
         this.ngAfterViewInit();
       }
       else {
         this.sharedapi.presentToast(data.msg);
       }
     }, error => {
       this.sharedapi.checkError(error);
     });
 
   }

  ngOnInit(): void {
    this.sharedapi.getRole()
    .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  ngAfterViewInit() {
    console.log("hello");
    this.loadGlamyoPatientList(0,this.perpage);
  }

  async loadGlamyoPatientList(pageIndex,perpage)
  {
    this.usersList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search='+this.search;
      this.loading = true;this.loaded = false;
      this.patientapi.getPatientList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.usersList = data.data;
          }else{
              this.usersList = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadGlamyoPatientList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadGlamyoPatientList(event.pageIndex,event.pageSize);
    }

    showModal(glamyo_patient_id) {
      this.walletForm.reset();
      this.patchWalletData(glamyo_patient_id);
      $('#myModal').modal();
    }
  
    hideModal() {
      $('#myModal').modal('hide');
    }

    async patchWalletData(glamyo_patient_id) {
      await this.patientapi.getWalletEditData(glamyo_patient_id).subscribe((response: any) => {
        if (response.status) {
          this.glamyoPatientId = glamyo_patient_id;
          this.walletForm.patchValue({
            'wallet': response.data.wallet
          });
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }

}
